import type { BeneficiaryContactPayload } from '@Application/Beneficiaries/BeneficiaryContacts/BeneficiaryContacts/Actions/beneficiaryContactsFetched';

export type BeneficiaryContactUpdatedAction = {
	type: 'BENEFICIARY_CONTACT_UPDATED';
	payload: BeneficiaryContactPayload;
	beneficiaryId: number;
};

export default (
	payload: BeneficiaryContactPayload,
	beneficiaryId: number,
): BeneficiaryContactUpdatedAction => ({
	type: 'BENEFICIARY_CONTACT_UPDATED',
	payload,
	beneficiaryId,
});
